import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAdLinkingInitiated.meta';

export const useTrackAdLinkingInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackAdLinkingInitiated = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackAdLinkingInitiated };
};
